import React, { type ReactNode } from 'react';

import { Navigate } from 'react-router-dom';

import { APP_ANONYMOUS_LANDING_PAGE } from '@app/routes/paths';
import { useAuthTokens } from '@app/store/zustand/auth/useAuthTokens';

type FeatureFlagRedirects = {
    authenticated?: string;
    notAuthenticated?: string;
};

interface FeatureFlagRoutesProps {
    element: ReactNode;
    isEnabled: boolean;
    redirects?: FeatureFlagRedirects;
}

export const FeatureFlagRoutes = ({ element, isEnabled = true, redirects }: FeatureFlagRoutesProps) => {
    const { isAuthenticated } = useAuthTokens();

    // Feature flag enabled, load component
    if (isEnabled) return element;

    // Feature flag disabled, redirect to the appropriate authenticated route
    if (isAuthenticated) return <Navigate to={redirects?.authenticated ?? '/'} relative="path" />;

    // Feature flag disabled but user not authenticated
    return <Navigate to={redirects?.notAuthenticated ?? APP_ANONYMOUS_LANDING_PAGE} relative="path" />;
};
